import React from 'react';
import type { Page } from '../../../types';
import { getSlugFromPage } from '../../../utils/routeUtils';
import {
    cnMobileBottomNavIcon,
    cnMobileBottomNavItem,
    cnMobileBottomNavLabel,
    MOBILE_BOTTOM_NAV_GRID_CLASS,
} from '../layoutNavTokens';
import { MOBILE_NAV_ITEMS } from './config';
import { handleSidebarNavClick } from './navHandlers';

interface MobileBottomNavProps {
    currentPage: Page;
    setCurrentPage: (page: Page) => void;
    accountSlot: React.ReactNode;
}

/** Barra inferior mobile — grid 6 colunas iguais (5 rotas + Mais). */
export function MobileBottomNav({ currentPage, setCurrentPage, accountSlot }: MobileBottomNavProps) {
    return (
        <div className={MOBILE_BOTTOM_NAV_GRID_CLASS}>
            <nav aria-label="Navegação principal" className="contents">
                {MOBILE_NAV_ITEMS.map((item) => {
                    const Icon = item.icon;
                    const isActive = currentPage === item.id;
                    return (
                        <a
                            key={item.id}
                            href={`/${getSlugFromPage(item.id)}`}
                            aria-current={isActive ? 'page' : undefined}
                            aria-label={item.label}
                            onClick={(e) => handleSidebarNavClick(e, setCurrentPage, item.id)}
                            className={cnMobileBottomNavItem()}
                        >
                            <Icon className={cnMobileBottomNavIcon(isActive)} aria-hidden />
                            <span className={cnMobileBottomNavLabel(isActive)}>{item.mobileLabel}</span>
                        </a>
                    );
                })}
            </nav>
            <div className="flex min-w-0 items-end justify-center">{accountSlot}</div>
        </div>
    );
}
